<template>
    <div>
      <!-- Basket Mobile >> Basket Desktop unten-->
      <div
          class="product__basket-mobile position-fixed w-100 b-0 l-0 px-prj2 pt-prj2 pb-4 bg-shade-light hide-for-large hide-for-print"
          v-bind:class="{ 'bg-error': !configurationComplete }">
        <div class="row">
          <div class="small-12 columns product__basket-mobile-split">
            <div class="product__basket-mobile-split-info">
              <div class="d-flex justify-content-between mb-1 mb-3@large" v-if="configurationComplete">
                <div class="text-xsmall">{{ 'txtExclVAT'|translate }}</div>
                <div class="text-small text-align-right" v-if="priceExclVat">{{ priceExclVat }}</div>
              </div>
              <template v-if="configurationComplete && normalPrice && savings">
                <div class="d-flex justify-content-between mb-1 mb-3@large">
                  <div class="text-xsmall">{{ 'txtBasketPriceRegulaer'|translate }} <span
                      class="text-xxsmall">{{ 'txtExclVAT'|translate }}</span></div>
                  <div class="text-small text-align-right">{{ normalPrice }}</div>
                </div>
                <div class="d-flex justify-content-between mb-1 mb-3@large">
                  <div class="text-xsmall">{{ 'txtBasketPriceSaved'|translate }} <span
                      class="text-xxsmall">{{ 'txtExclVAT'|translate }}</span></div>
                  <div class="text-small text-align-right">{{ savings }}</div>
                </div>
              </template>
              <div class="d-flex justify-content-between align-items-end" v-if="configurationComplete">
                <div class="font-weight-bold text-xsmall">{{ 'txtInclVAT'|translate(globalConfig.vat) }}</div>
                <div class="font-weight-bold text-align-right" v-if="priceInclVat">{{ priceInclVat }}</div>
              </div>
              <div class="d-flex justify-content-between align-items-end mt-1"
                   v-if="configurationComplete && liefertermin">
                <div class="text-xsmall">{{ 'txtVersandterminShort' | translate }}</div>
                <div class="text-small text-align-right">{{ liefertermin }}</div>
              </div>
              <div class="d-flex py-2 text-white text-small line-height-12" v-if="!configurationComplete">
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px"
                     viewBox="0 0 36 36">
                  <circle cx="18" cy="18" r="18" fill="#fff"/>
                  <path
                      d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z"
                      fill="#e94d47"/>
                </svg>
                {{ statusMsg }}
              </div>
            </div>
            <div class="mt-2">
              <a class="btn w-100 btn-basket" :disabled="!configurationComplete"
                 @click="toBasket">{{ 'btnAddToBasket' | translate }}</a>
            </div>
          </div>
        </div>
      </div>

        <!-- Basket Desktop -->
      <div class="product__basket-desktop mb-3">
            <div class="product__basket-title p-4 bg-secondary text-white font-weight-bold text-center show-for-large">
                {{'txtMyOffer'|translate}}
            </div>
            <div class="p-prj2 pt-4 bg-shade-light show-for-large">
                <PrintQ3DOverlay
                    v-if="this.configuratorService.isConfigTypePresent(printqService.TYPE)"
                />
                <div class="d-flex justify-content-between" :class="{ 'mb-2': savings, 'mb-3': !savings }" >
                    <div class="text-xsmall">{{'txtExclVAT'|translate}}</div>
                    <div class="text-small text-align-right" v-if="priceExclVat">{{priceExclVat}}</div>
                </div>

                <template v-if="normalPrice && savings">
                  <div class="d-flex justify-content-between align-items-end mb-2">
                    <div class="text-xsmall">{{ 'txtBasketPriceRegulaer'|translate }} <span
                        class="text-xxsmall">{{ 'txtExclVAT'|translate }}</span></div>
                    <div class="text-small text-align-right">{{ normalPrice }}</div>
                  </div>
                  <div class="d-flex justify-content-between align-items-end mb-2">
                    <div class="text-xsmall">{{ 'txtBasketPriceSaved'|translate }} <span
                        class="text-xxsmall">{{ 'txtExclVAT'|translate }}</span></div>
                    <div class="text-small text-align-right">{{ savings }}</div>
                  </div>
                  <hr class="mb-2 mt-2 bg-white"/>
                </template>

                <div class="d-flex justify-content-between align-items-end">
                    <div class="font-weight-bold text-xsmall">{{'txtInclVAT'|translate(globalConfig.vat)}}</div>
                    <div class="font-weight-bold text-align-right" v-if="priceInclVat">{{priceInclVat}}</div>
                </div>

              <div class="d-flex justify-content-between align-items-end mt-3" v-if="this.configuratorService.observableData.herstellkosten">
                <div class="text-xsmall">Herstellkosten (exkl. MwSt)</div>
                <div class="text-small text-align-right">{{this.configuratorService.observableData.herstellkosten.currency}} {{this.configuratorService.observableData.herstellkosten.exclVat}}</div>
              </div>

                <div class="d-flex mt-2 p-2 bg-error text-white text-small line-height-12" v-if="!configurationComplete">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#fff"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#e94d47"/></svg>
                    {{ statusMsg }}
                </div>
                <hr class="mb-2 mt-2 bg-white" />
                <div class="d-flex justify-content-between align-items-end" v-if="liefertermin">
                    <div class="text-xsmall">{{ 'txtVersandterminShort' | translate }}</div>
                    <div class="text-small text-align-right">{{ liefertermin }}</div>
                </div>
                <div class="mt-4">
                    <a class="btn w-100 btn-basket" :disabled="!configurationComplete" @click="toBasket">{{shopItemId ? 'btnUpdateBasket' : 'btnAddToBasket' |translate }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import PrintQ3DOverlay from "./PrintQ3DOverlay";

export const PRODUKTIONSVERFAHREN = "produktionsverfahren";
    export const ADDITIONAL_VALUE_PRODUKTIONSDAUER_PRICEBOX = "produktionsdauerPriceBox";

export default {
  name: 'PriceBox',
  props:
      ['shopItemId'],
  inject: ['globalConfig', 'configuratorService', 'printqService'],
  data() {
        return {
          basketUrl: window.webroot + window.languagepath + '/shop-basket.html',
          itemUrl: `${webroot}myinterfaces/${languagepath}/shop/session/basket/items/`
        }
      },
      methods: {
        toBasket: function() {
          this.configuratorService.newest = null;
          this.configuratorService.newest_configoption = null;
              this.configuratorService.validate().then(() => {
                if(this.configurationComplete) {
                    this.configuratorService.addOrUpdateToBasket(this.shopItemId)
                        .then(()=>this.configuratorService.navigateToBasket())
                }
            })
          }
        },
        computed: {
            priceExclVat: function () {
                return this.configuratorService.observableData.data.prices.pricewithoutvat;
            },
            priceInclVat: function () {
                return this.configuratorService.observableData.data.prices.pricewithvat;
            },
            normalPrice: function() {
              return this.configuratorService.observableData.data.prices.normalpricewithoutvat;
            },
            savings: function() {
              return this.configuratorService.observableData.data.prices.savings;
            },
            liefertermin: function () {
              // todo: format date
              // return this.configuratorService.observableData.data.shippingdate;
              return this.configuratorService.observableData.data.variables?.liefertermin;
            },
          configurationComplete: function () {
            return this.configuratorService.isConfigurationComplete();
          },
          statusMsg: function () {
            return this.configuratorService.getOverallMsg();
          }
        },
  components: {PrintQ3DOverlay}
}
</script>